
import { IEk } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'fiko-yazidan-resme',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NzTagModule,
    NzInputModule,
  ],
  templateUrl: './yazidan-resme.component.html',
  styleUrl: './yazidan-resme.component.scss'
})
export class YazidanResmeComponent extends FikoYTKokBilesenComponent {
  /** */
  private _ek: IEk | any;
  public get ek(): IEk | any {
    return this._ek;
  }
  @Input() public set ek(v: IEk | any) {
    this._ek = v;
    this.ekChange.emit(v);
    this.CD.detectChanges();
  }
  @Output() ekChange: EventEmitter<IEk> = new EventEmitter<IEk>();

}
